import { render } from "./ContainerPositionSelector.vue?vue&type=template&id=4f012cc9"
import script from "./ContainerPositionSelector.vue?vue&type=script&lang=js"
export * from "./ContainerPositionSelector.vue?vue&type=script&lang=js"

import "./ContainerPositionSelector.vue?vue&type=style&index=0&id=4f012cc9&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__